import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IFileNotFoundError extends IBaseSosErrorParams {
	kind: 'fileNotFoundError';
}

export default class FileNotFoundError extends AppletError {
	constructor(parameters: IFileNotFoundError) {
		super({
			...parameters,
			kind: 'appletError',
		});
		this.name = 'FileNotFoundError';
	}
}
